const addResolutionWithExecution = {
    namespaced: true,
    state: {
        visible: false,

        from: null,
        fromSet: false,
        text: '',
        controlDate: null,
        controlDateRange: null,

        resolve: null,

        executers: [],

        executionText: '',
        executionFiles: [],
        executionDate: null,
        minExecutionDate: null,
    },
    mutations: {
        SET_VISIBLE(state, payload) {
            state.visible = payload;
        },
        SET_FROM(state, payload) {
            state.from = payload;
        },
        SET_FROMSET(state, payload) {
            state.fromSet = payload;
        },
        SET_TEXT(state, payload) {
            state.text = payload;
        },
        SET_RESOLVE(state, payload) {
            state.resolve = payload;
        },
        SET_EXECUTERS(state, payload) {
            state.executers = payload;
        },
        SET_CONTROLDATE(state, payload) {
            state.controlDate = payload ? this._vm.$moment(payload) : null;
        },
        SET_CONTROLDATERANGE(state, payload){
            state.controlDateRange = payload;
        },
        SET_EXECUTION_TEXT(state, payload) {
            state.executionText = payload;
        },
        SET_EXECUTION_FILES(state, payload) {
            state.executionFiles = payload;
        },
        SET_EXECUTION_DATE(state, payload) {
            state.executionDate = payload;
        },
        SET_MIN_EXECUTION_DATE(state, payload) {
            state.minExecutionDate = payload;
        },
    },
    actions: {
        async open({ dispatch, commit }, { controlDate, minExecDate, from }) {
            if (from) {
                commit('SET_FROM', from);
                commit('SET_FROMSET', true);
            }
            else {
                commit('SET_FROM', null);
                commit('SET_FROMSET', false);
            }

            commit('SET_TEXT', '');
            commit('SET_CONTROLDATE', controlDate);

            commit('SET_MIN_EXECUTION_DATE', this._vm.$moment(minExecDate).format('YYYY-MM-DD'));

            let Max = '';
            let Min = '';
            let max = '';

            if (controlDate)
                max = this._vm.$moment(controlDate).startOf('day');

            let min = this._vm.$moment(await dispatch('documents/references/getTimestamp', null, { root: true })).startOf('day');

            if (max && max.isValid()) {
                Max = max.format('YYYY-MM-DD');

                if (min && min.isValid() && min.isBefore(max))                           
                    Min = min.format('YYYY-MM-DD'); 
                else
                    Min = Max;
            }
            else if (min && min.isValid()) {
                Min = min.format('YYYY-MM-DD');
            }

            commit('SET_CONTROLDATERANGE', { Max, Min });
            commit('SET_EXECUTERS', []);

            commit('SET_EXECUTION_TEXT', '');
            commit('SET_EXECUTION_FILES', []);
            commit('SET_EXECUTION_DATE', null);

            commit('SET_VISIBLE', true);

            return new Promise((resolve) => {
                commit('SET_RESOLVE', resolve);
            });
        },
        async ok({ commit, state }) {
            commit('SET_VISIBLE', false);
            state.resolve({ 
                from: state.from,
                text: state.text,
                executers: state.executers,
                controldate: (state.controlDate? state.controlDate.format('YYYY-MM-DD') : null),
                executionText: state.executionText,
                executionFiles: state.executionFiles,
                executionDate: state.executionDate
            });
        },
        async cancel({ commit, state }) {
            commit('SET_VISIBLE', false);
            state.resolve({ isCancelled: true, message: "Cancelled" });
        },

    },
    getters: {
        isVisible: (s) => s.visible,
        isValid: () => true,
        isFromSet: (s) => s.fromSet,
        getFrom: (s) => s.from,
        getText: (s) => s.text,
        getExecuters: (s) => s.executers,
        getControlDate: (s) => s.controlDate ? s.controlDate.format('YYYY-MM-DD') : '',
        getControlDateRange: (s) => s.controlDateRange,
        getExecutionText: (s) => s.executionText,
        getExecutionFiles: (s) => s.executionFiles,
        getExecutionDate: (s) => s.executionDate,
        getMinExecutionDate: (s) => s.minExecutionDate
    }
}

export default addResolutionWithExecution;